export const apiUrl = process.env.REACT_APP_INTERNAL_API_URL;
export const gqlApiUrl = process.env.REACT_APP_GQL_API_URL;
export const apiUrlUpdate =
  process.env.REACT_APP_UPDATER_API_URL || "https://updater.duskrise.com";
